import(/* webpackMode: "eager", webpackExports: ["CaseStudyContent"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/case-study/case-study-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTA"] */ "/codebuild/output/src592612800/src/mtalkz.com/components/CTA/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src592612800/src/mtalkz.com/node_modules/next/dist/client/image-component.js");
